import React from 'react'
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom'
import { nanoid } from 'nanoid'

// import { Home } from './routes/Home'
import { Room } from './routes/Room'

import { LoremIpsum } from './components/LoremIpsum'
import { NotFound } from './components/NotFound'

const Routes: React.FC = () => {
    return (
        <>
            <Switch>
                <Route path="/lorem-ipsum" component={LoremIpsum} />
                {/* <Route path="/" exact component={Home} /> */}
                <Route path={['/:room']} component={Room} />
                <Route exact path="/">
                    <Redirect to={`/${nanoid()}`} />
                </Route>
                <Route path="/" component={NotFound} />
            </Switch>
        </>
    )
}

const App: React.FC = () => {
    return (
        <>
            <Router>
                <Routes />
            </Router>
        </>
    )
}

export default App
